import { inject, observer } from 'mobx-react';
import React, { Component } from 'react'
import {FormGroup, Button, Col, Input, InputGroup, Label, Row} from 'reactstrap'
import lscache from 'lscache'
import FormInput from '../../../comum/components/FormInput';
import FormInputSimples from '../../../comum/components/FormInputSimples';
import FormSelect from '../../../comum/components/FormSelect';
import ModalForm from '../../../comum/components/ModalFormAlterado';
import SelectFiltro from '../../../comum/components/SelectFiltro';
import FormSelectSimples from '../../../comum/components/FormSelectSimples';
import {isInvalidoCodigoContainer} from "../../../../utils/validadores";

@observer
class ModalNovaSolicitacao extends Component {
    constructor(props) {
        super(props);
        this.controller = props.controller;

    }
    componentDidMount(){
        this.controller.carregarListaResponsavelCusto()
    }

    componentWillUnmount(){
        this.controller.resetarFormularioSolicitacao()
    }

    onChange(value){
        value = value.toUpperCase();
        this.controller.setContainer(value)        
    }


    isInRole(valor, valor2){


        if(lscache.get("Perfil").find(item => item == valor)){
            return true
        }

        if(lscache.get("Perfil").find(item => item == valor2)){
            return true
        }

    }

    render() {
        let listaContainer = this.controller.listaContainer;
        let navioSelecionado= this.controller.navioSelecionado;
        let opcoesResponsavelCusto = this.controller.opcoesResponsavelCusto;
        let tamLabel = 4;
        let tamCampo = 8;
        
        return ( 
            <ModalForm
                salvando={this.controller.loading}
                onClickSalvar={this.controller.ModalSolicitacao}
                labelConfirmar="CONFIRMAR"
                labelCancelar="FECHAR"
                onClickCancelar={() => this.controller.setEstadoModalSolicitacao(false)}
            >
                <div style={{minWidth: "375px"}}>
                    <h2>Nova Solicitação</h2>
                    <div>
                        <FormGroup className="align-items-baseline p-0 mb-1" row>
                            <Label sm={tamLabel} md={tamLabel} lg={tamLabel} xl={tamLabel}>N° Booking:</Label>
                            <FormInput sm={tamCampo} md={tamCampo} lg={tamCampo} xl={tamCampo}
                                onChange={e => this.controller.setNumeroBooking(e.target.value)}
                                onBlur={this.controller.carregarNavio}
                            />
                        </FormGroup>
                        {
                        navioSelecionado.length ?
                            <FormGroup className="align-items-baseline p-0 mb-2" row>
                                <Label sm={tamLabel} md={tamLabel} lg={tamLabel} xl={tamLabel}>Navio:</Label>
                                <FormInputSimples sm={tamCampo} md={tamCampo} lg={tamCampo} xl={tamCampo}
                                    value={navioSelecionado}
                                    bloqueado
                                />
                            </FormGroup> 
                            : null
                        }
                    </div>
                    <div>
                        {
                            listaContainer.map((item, index) => {
                                return (
                                    <FormGroup key={index} className="align-items-baseline mb-1 p-0" row>
                                        <Label sm={tamLabel} md={tamLabel} lg={tamLabel} xl={tamLabel}>Container {index+1}:</Label>
                                        <Col sm={tamCampo} md={tamCampo} lg={tamCampo} xl={tamCampo}>
                                            <InputGroup className="w-100">
                                                <Input type="text" value={item} disabled 
                                                />
                                                <div className="input-group-append">
                                                    <Button color="danger" onClick={() => this.controller.removeContainer(item)}>Remover</Button>
                                                </div>
                                            </InputGroup>
                                        </Col>
                                    </FormGroup>
                                )
                            })
                        }
                        
                        <FormGroup className="align-items-baseline p-0 mb-1" row>
                            <Label sm={tamLabel} md={tamLabel} lg={tamLabel} xl={tamLabel}>Container:</Label>
                            <FormInputSimples className="mb-0" sm={tamCampo} md={tamCampo} lg={tamCampo} xl={tamCampo}
                                placeholder="Ex: MABC1234567" 
                                validador={isInvalidoCodigoContainer}
                                value={this.controller.container} 
                                onChange={(event) => this.onChange(event.target.value)} 
                            />
                        </FormGroup>
                        <Row>
                            <Button className="btn-com-bordas-primary btn-filtrar w-100" onClick={this.controller.addContainer}>Adicionar Container</Button>
                        </Row>
                    </div>
                    {
                        this.isInRole("CLIENTE", "ATENDIMENTO") 
                        &&
                        <FormGroup className="align-items-baseline" row>
                            <Label sm={tamLabel} md={tamLabel} lg={tamLabel} xl={tamLabel}>Resp. Custo:</Label>
                            <FormSelectSimples sm={tamCampo} md={tamCampo} lg={tamCampo} xl={tamCampo}
                                itens={opcoesResponsavelCusto}
                                onChange={this.controller.setResponsavelCustoSelecionado}
                                bloqueado={this.controller.carregandoListaResponsavel}
                            />
                        </FormGroup>
                    }
                </div>
            </ModalForm>
         );
    }
}
 
export default ModalNovaSolicitacao


// WEBPACK FOOTER //
// ./src/modules/agendamento/entrada-antecipada/components/ModalNovaSolicitacao.js